export function formatPortalCountry(code: string | null, locale: string): string | null {
  if (!code?.trim()) return null;
  try {
    const display = new Intl.DisplayNames([locale], { type: 'region' });
    return display.of(code.trim().toUpperCase()) ?? code;
  } catch {
    return code;
  }
}

export function companyDisplayHeading(data: {
  tenant_display_name: string | null;
  tenant_legal_name: string;
  tenant_name: string;
}): string {
  return (
    data.tenant_display_name?.trim() || data.tenant_legal_name?.trim() || data.tenant_name || ''
  );
}
